<template>
  <header 
    class="header0 home-page-wrapper"
    :class="{ 
      'scrolled': isScrolled || currentRoute !== '/' 
    }"
  >
    <div class="home-page">
      <div class="header0-logo">
        <router-link to="/">
          <img width="100%" src="/static/logo.png" alt="湖北泰跃卫星技术发展股份有限公司logo" />
        </router-link>
      </div>
      
      <!-- 移动端菜单按钮 -->
      <div 
        v-if="isMobile" 
        class="header0-mobile-menu"
        @click="toggleMobileMenu"
      >
        <em></em>
        <em></em>
        <em></em>
      </div>
      
      <!-- 导航菜单 -->
      <div 
        class="header0-menu"
        :class="{ 'open': isMobileMenuOpen }"
      >
        <ul>
          <li 
            v-for="item in menuItems" 
            :key="item.name"
            class="header0-item"
            @mouseenter="setActivePage(item.children.href)"
            @mouseleave="setActivePage(currentRoute)"
          >
            <router-link 
              :to="item.children.href"
              class="header0-item-block"
              @click="closeMobileMenu"
            >
              {{ item.children.children[0].children }}
            </router-link>
            <div 
              class="nav_container"
              :class="{ 'nav_active': isCurrentRoute(item.children.href) }"
            ></div>
            <div 
              class="nav_container"
              :class="{ 'nav_active': activePage === item.children.href }"
            ></div>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'Nav',
  data() {
    return {
      menuItems:[
      {
        name: "item0",
        className: "header0-item",
        children: {
          href: "/",
          children: [{ children: "首页", name: "text" }],
        },
      },
      {
        name: "item2",
        className: "header0-item",
        children: {
          href: "/news",
          children: [{ children: "新闻资讯", name: "text" }],
        },
      },
      {
        name: "item3",
        className: "header0-item",
        children: {
          href: "/product",
          children: [{ children: "产品服务", name: "text" }],
        },
      },
      {
        name: "item4",
        className: "header0-item",
        children: {
          href: "/special",
          children: [{ children: "数字乡村", name: "text" }],
        },
      },
      {
        name: "item5",
        className: "header0-item",
        children: {
          href: "/case",
          children: [{ children: "服务案例", name: "text" }],
        },
      },
      {
        name: "item6",
        className: "header0-item",
        children: {
          href: "/about",
          children: [{ children: "关于我们", name: "text" }],
        },
      },
    ],
      isMobile: false,
      isMobileMenuOpen: false,
      isScrolled: false,
      activePage: '',
      currentRoute: ''
    }
  },
  mounted() {
    // 初始化当前路由
    this.currentRoute = this.$route.path
    this.activePage = this.currentRoute
    
    // 检测设备类型
    this.checkDeviceType()
    window.addEventListener('resize', this.checkDeviceType)
    
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    
    // 监听路由变化
    this.$router.afterEach((to) => {
      this.currentRoute = to.path
      this.activePage = to.path
      this.closeMobileMenu()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceType)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    checkDeviceType() {
      this.isMobile = window.innerWidth < 768
    },
    handleScroll() {
      const scrollY = window.scrollY
      this.isScrolled = scrollY > 200
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    setActivePage(path) {
      this.activePage = path
    },
    isCurrentRoute(path) {
      return this.$route.path + (this.$route.hash || '') === path
    }
  }
}
</script>

<style scoped>
.header0 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  height: 80px;
}

.header0.home-page-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
}

.header0.home-page-wrapper:not(.scrolled) {
  background: transparent;
}

.header0.scrolled {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  height: 70px;
}

.home-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.header0-logo {
  width: 180px;
  height: 40px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.header0-logo img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.header0.scrolled .header0-logo {
  width: 150px;
  height: 34px;
}

.header0-menu {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.header0-menu ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
}

.header0-item {
  position: relative;
  margin-left: 40px;
}

.header0-item:first-child {
  margin-left: 0;
}

.header0-item-block {
  display: inline-block;
  padding: 8px 16px;
  color: rgba(255, 255, 255, 0.95);
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.5px;
  position: relative;
  border-radius: 4px;
}

.header0.scrolled .header0-item-block {
  color: #333;
}

.header0-item:hover .header0-item-block {
  color: #1890ff;
  background: rgba(24, 144, 255, 0.1);
}

.header0.scrolled .header0-item:hover .header0-item-block {
  background: rgba(24, 144, 255, 0.08);
}

.nav_container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  border-radius: 2px 2px 0 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav_container.nav_active {
  width: 60%;
}

/* 移动端样式 */
.header0-mobile-menu {
  display: none;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s ease;
}

.header0-mobile-menu em {
  display: block;
  width: 26px;
  height: 2px;
  background: rgba(255, 255, 255, 0.9);
  margin-bottom: 6px;
  transition: all 0.3s ease;
  border-radius: 1px;
}

.header0.scrolled .header0-mobile-menu em {
  background: #333;
}

.header0-mobile-menu.active em:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.header0-mobile-menu.active em:nth-child(2) {
  opacity: 0;
  transform: translateX(-10px);
}

.header0-mobile-menu.active em:nth-child(3) {
  transform: rotate(-45deg) translate(8px, -8px);
}

@media (max-width: 768px) {
  .header0 {
    height: 70px;
  }
  
  .header0.scrolled {
    height: 65px;
  }
  
  .home-page {
    padding: 0 20px;
  }
  
  .header0-logo {
    width: 140px;
    height: 32px;
  }
  
  .header0.scrolled .header0-logo {
    width: 130px;
    height: 30px;
  }
  
  .header0-mobile-menu {
    display: block;
  }
  
  .header0-menu {
    position: fixed;
    top: 70px;
    left: -100%;
    width: 100%;
    height: calc(100vh - 70px);
    background: rgba(255, 255, 255, 0.99);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  }
  
  .header0.scrolled .header0-menu {
    top: 65px;
    height: calc(100vh - 65px);
  }
  
  .header0-menu.open {
    left: 0;
  }
  
  .header0-menu ul {
    flex-direction: column;
    padding: 30px 20px;
  }
  
  .header0-item {
    margin: 0 0 20px 0;
  }
  
  .header0-item-block {
    font-size: 16px;
    color: #333;
    padding: 12px 16px;
    display: block;
    border-radius: 6px;
    transition: all 0.3s ease;
  }
  
  .header0-item-block:hover {
    background: rgba(24, 144, 255, 0.1);
    color: #1890ff;
  }
}
</style>